<template>
  <b-overlay :show="loading" opacity="0.8">
    <validation-observer ref="newUserForm" #default="{invalid}">
      <b-form ref="form" @submit.prevent="onUpdateUser">
        <div :style="{
            height: readOnly ? '450px' : '600px', 
            borderBottom: readOnly ? '' : 'solid lightgray 2px'
          }"
        >
          <div v-if="!readOnly" class="d-flex align-items-center mb-3">
            <feather-icon
              icon="ClockIcon"
              size="19"
            />
            <h4 class="mb-0 ml-50">
              Social History
            </h4>
          </div>
  
          <b-row>
            <b-col cols="12" md="12">
              <b-form-group>
                <validation-provider #default="{ errors }" name="Alcohol" rules="">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Alcohol</label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-checkbox 
                        v-model="socialHistory.alcohol" 
                        name="alcohol" 
                        :disabled="disableForm"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group v-if="socialHistory.alcohol">
                <validation-provider #default="{ errors }" name="Bottles/day" rules="required">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Bottles/day<span style="color: tomato">*</span></label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-input 
                        v-model="socialHistory.bottles_per_day"
                        placeholder="5"
                        :disabled="disableForm"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider #default="{ errors }" name="Smoking" rules="">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Smoking</label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-checkbox 
                        v-model="socialHistory.smoking" 
                        name="smoking" 
                        :disabled="disableForm"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group v-if="socialHistory.smoking">
                <validation-provider #default="{ errors }" name="Packs/day" rules="required">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Packs/day<span style="color: tomato">*</span></label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-input 
                        v-model="socialHistory.packs_per_pay"
                        placeholder="5"
                        :disabled="disableForm"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider #default="{ errors }" name="Occupation" rules="">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Occupation</label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-input 
                        v-model="socialHistory.occupation"
                        placeholder=""
                        :disabled="disableForm"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider #default="{ errors }" name="Activity Level" rules="">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Activity Level</label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <v-select 
                        v-model="socialHistory.activity_level" 
                        :options="[
                          {
                            label: 'Minimal',
                            value: 'minimal'
                          }, 
                          {
                            label: 'Moderate',
                            value: 'moderate'
                          }, 
                          {
                            label: 'Increased',
                            value: 'increased'
                          }
                        ]" 
                        :close-on-select="true" 
                        :reduce="val => val.value" 
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
                        :clearable="false" 
                        :disabled="disableForm"
                        label="label" 
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider #default="{ errors }" name="Additional History" rules="">
                  <b-row>
                    <b-col cols="12" md="6">
                      <label>Additional History</label>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-form-textarea 
                        v-model="socialHistory.additional_history"
                        placeholder=""
                        :disabled="disableForm"
                      />
                    </b-col>
                  </b-row>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <b-button
          v-if="!readOnly"
          class="float-right mt-2"
          style="width: 200px"
          variant="primary"
          block
          type="submit"
          :disabled="invalid || disableForm || loading"
        >
          Update
        </b-button>
      </b-form>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  BFormCheckbox, 
  BFormTextarea,
  BForm, BFormInput, 
  BOverlay, BRow, BCol,
  BButton, BFormGroup, 
  BFormInvalidFeedback
} from "bootstrap-vue"

import { get, cloneDeep } from 'lodash';
import { required } from '@validations';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

import vSelect from 'vue-select'
import CancerSelect from "@core/components/shared/admin/selects/CancerSelect.vue"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    vSelect,

    BRow,
    BCol, 
    BForm, 
    BButton,
    BOverlay,
    BFormInput,
    BFormGroup, 
    BFormCheckbox,
    BFormTextarea,
    BFormInvalidFeedback,
    
    // validations
    ValidationProvider,
    ValidationObserver,

    CancerSelect
  },
  directives: {},
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    patientData: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data(){
    return {
      loading: false,

      socialHistory: null,

      required,
    }
  },
  computed: {
    hasBasicUpdatePermission(){
      return this.can('patients:CanUpdate');
    },
    disableForm(){
      return !this.can('patients:CanUpdate') || this.readOnly
    },
  },
  watch: {
    patientData: {
      handler(data){
        this.socialHistory = {
          packs_per_pay: '',
          bottles_per_day: '',
          ...cloneDeep(data.social_history)
        };
      }, 
      immediate: false,
      deep: true
    }
  },
  created() {
    this.socialHistory = {
      packs_per_pay: '',
      bottles_per_day: '',
      ...cloneDeep(this.patientData.social_history)
    };
  },
  methods: {
    async onUpdateUser() {
      try {
        this.loading = true;

        await this.useJwt().mainService.patients.updateMedicalHistory(this.patientData.id, {
          social_history: this.socialHistory
        });
        this.$emit('refresh')

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            variant: 'success',
            icon: 'CheckCircleIcon',
            text: `Patient profile updated successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            variant: 'danger',
            text: error_message,
            icon: 'AlertTriangleIcon',
          },
        });
      } finally {
        this.loading = false
      }
    },
  }
}
</script>
